<template>
  <div class="rs-form-external-input">
    <RsFormInput
      :id="`${id}`"
      ref="textField"
      :value="value"
      :type="type"
      readonly
      @input="$emit('input', $event)"
    />
    <div class="rs-form-external-link">
      <a
        v-if="value"
        :href="value"
        target="_blank"
      >
        <RsIcon
          weight="far"
          icon="external-link-alt"
        />
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsFormExternalInput',

  props: {
    id: [Number, String],
    type: {
      type: String,
      default: 'text',
      validator: (prop?: string) => [
        'text',
        'number',
        'email',
        'password',
        'search',
        'url',
        'tel',
        'time',
        'range',
        'color',
      ].includes(prop ?? 'text'),
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
});
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
$external-height: 50px;
$external-padding: 3px;
$button-height: 32px;
$external-input-height: 22px;
.rs-form-external-input {
  position: relative;
  padding: $external-padding;
  width: 100%;
  height: $external-height;
  display: flex;
  line-height: $input-line-height;
  border-radius: $input-radius;
  color: $primary-color;
  font-size: $input-font-size;
  box-sizing: border-box;

  .rs-input{
    margin-bottom: 0;
    width: 100%;
    &:focus{
      box-shadow: none !important;
      border-color: $info;
    }
    ::v-deep input {
      color: $white;
      border: none;
      background: $tertiary-dark;
      box-shadow: none !important;
      padding: 1rem 2.5rem 1rem 1rem;
    }
  }

  .rs-form-external-link {
    z-index: 10;
    position: absolute;
    right: .25rem;
    top: 50%;
    transform: translateY(-50%);
    padding: 0;
    width: $button-height;
    height: $button-height;
    transition: all .25s ease-in-out;
    background: none;
    display: flex;
    justify-content: center;
    align-items: center;
    a {
      color: $white;
    }
  }
}
</style>
